import React, { useState, useEffect } from "react";
import { Link, useParams } from "react-router-dom";
import { sendMessage } from "../../service/ContactService";
import UserFooter from "./UserFooter";
import { useToast } from "../toast/ToastProvider";
import Header from "./Header";
import { fetchDropdownByCategoryWise } from "../../service/DropdownService";
import { fetchPagesById } from "../../service/PageService";
import { apiUrl } from "../../config";
import { fetchDiscussionBySourceId } from "../../service/DiscussionService";
import DiscussionForm from "../admin/DiscussionForm";

const UsersPage = () => {
  const { id } = useParams();
  const toast = useToast();
  const [categoryList, setCategoryList] = useState([]);
  const [dropdownList, setDropdownList] = useState([]);
  const [discussion, setDiscussion] = useState([]);
  const [page, setPage] = useState({});
  const [selectedCategory, setSelectedCategory] = useState(null);
  useEffect(() => {
    getCategories();
    getPage();
  }, []);

  useEffect(() => {
    if (id) getComments(id);
  }, [id]);


  const getCategories = async () => {
    try {
      const data = await fetchDropdownByCategoryWise("HealthCare Category");
      const sortedData = data.sort((a, b) => a.title.localeCompare(b.title));
      setDropdownList(sortedData);
    } catch (err) {
      console.error("Failed to fetch dropdown list:", err);
    }
  };

  const getPage = async () => {
    try {
      const data = await fetchPagesById(id);
      setPage(data);
    } catch (err) {
      console.error("Failed to fetch Page list:", err);
    }
  };

  const getComments = async (id) => {
    try {
      const res = await fetchDiscussionBySourceId(id, "page");

      const filtered = res.filter(
        (item) => item.source === "page" && String(item.source_id) === String(id)
      );


      setDiscussion(filtered)
    } catch (err) {
      toast(err.message || "Failed to fetch discussions", "ERROR")
    }
  }

  return (
    <>
      {/* <div id="preloader">
        <div id="status">
          <img src="/images/preloader.gif" id="preloader_image" alt="loader" />
        </div>
      </div> */}
      <a href="javascript:;" id="return-to-top">
        <i className="fas fa-angle-double-up"></i>
      </a>
      <Header />
      <div className="container-fluid banner-marquee-container">
        <div className="row marquee-row">
          <marquee
            className="marquee-announcement-home-page"
            behavior="scroll"
            direction="left"
            scrollamount="8"
          >
            <div style={{ display: "inline-block", whiteSpace: "nowrap" }}>
              <span role="img" aria-label="announcement" className="fs-5 me-2">
                📢
              </span>
              <span className="fw-bold ">
                This web vvrhcs has many Healthcare sites to register your name
                and company please contact us-
                <a
                  href="#"
                  style={{
                    textDecoration: "none",
                    color: "#ffffff",
                    marginLeft: "10px",
                  }}
                >
                  <span>
                    <i className="fas fa-phone me-2"></i>
                  </span>
                  04362 - 238 235
                </a>
              </span>
            </div>
          </marquee>
        </div>
      </div>
      <div className="blog-page-main-container float_left ptb-100">
        <div className="container">
          <div className="row">
            {/* Left Section */}
            <div className="col-lg-8 col-md-12 col-sm-12 col-12">
              <div className="blog-single-main-page">
                <div className="blog-box p-0">
                  {page.bannerImageUrl && (
                    <div className="img-icon">
                      <img src={apiUrl + "/" + page.bannerImageUrl} alt="" />
                      {/* <p className="text-center">
                      08
                      <br />
                      july
                    </p> */}
                    </div>
                  )}

                  <div className="blog-content">
                    <h3 className="p-0">{page.title}</h3>
                    <div>
                      <div dangerouslySetInnerHTML={{ __html: page.content }} />{" "}
                      <img src="/images/quote.png" alt="quote" />
                    </div>
                  </div>
                </div>
              </div>

              <div className="mt-4">
                <DiscussionForm sourceId={id} onSuccess={() => getComments(id)} />

                {discussion.length > 0 ? (
                  discussion
                    .filter((dis) => dis.status?.toLowerCase() === "approved")
                    .map((dis, index) => {
                      const dateOnly = new Date(dis.create_timestamp)
                        .toLocaleDateString("en-GB");
                      return (
                        <div key={index} className="p-3 mb-3 border rounded shadow-sm mt-4">
                          <h6 className="text-primary mb-3" style={{textTransform:'capitalize'}}>{dis.title || "No Title"}</h6>
                          <p className="mb-3 text-dark">{dis.description}</p>
                          <small className="text-dark">{dateOnly}</small>
                        </div>
                      );
                    })
                ) : (
                  <p className="text-muted mt-5"></p>
                )}


              </div>

            </div>


            {/* Right Sidebar */}
            <div className="col-lg-4 col-md-12 col-sm-12 col-12">
              <aside className="blog-right-sidebar resp-30">
                <div
                  className=" p-4 d-none d-md-block"
                  style={{ background: "#00B3FF" }}
                >
                  <h4 className="fw-bold mb-4 text-white">CATEGORIES</h4>

                  <ul className="list-unstyled">
                    {dropdownList.map((item, index) => (
                      <CategoryItem
                        category={item.title}
                        key={index}
                        onClick={() => {
                          setSelectedCategory(item.title);
                          window.scrollTo({ top: 0, behavior: "smooth" });
                        }}
                      />
                    ))}
                  </ul>
                </div>
              </aside>
            </div>
          </div>
        </div>
      </div>

      <UserFooter />
    </>
  );
};

export default UsersPage;

const CategoryItem = ({ category, onClick }) => (
  <li className="mb-2">
    <div
      className="d-flex align-items-center gap-2"
      role="button"
      onClick={onClick}
    >
      <i className="fas fa-heartbeat fa-1x text-white"></i>
      <Link
        to={`/category/${category}`}
        className=" text-white text-decoration-none"
      >
        {category}
      </Link>
    </div>
  </li>
);
